var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8093 20.776C20.2936 20.4819 22.7344 19.8956 25.0813 19.0293C23.0938 16.8277 21.9956 13.966 21.9999 11V10.0667V10C21.9999 7.87827 21.1571 5.84344 19.6568 4.34315C18.1565 2.84286 16.1217 2 13.9999 2C11.8782 2 9.84339 2.84286 8.3431 4.34315C6.8428 5.84344 5.99995 7.87827 5.99995 10V11C6.00397 13.9662 4.90527 16.8279 2.91728 19.0293C5.22795 19.8827 7.66395 20.476 10.1906 20.776M17.8093 20.776C15.2786 21.0762 12.7213 21.0762 10.1906 20.776M17.8093 20.776C18.0014 21.3758 18.0492 22.0125 17.9487 22.6343C17.8483 23.2561 17.6024 23.8453 17.2311 24.3541C16.8599 24.8629 16.3737 25.2768 15.8122 25.5621C15.2507 25.8475 14.6298 25.9962 13.9999 25.9962C13.3701 25.9962 12.7492 25.8475 12.1877 25.5621C11.6262 25.2768 11.14 24.8629 10.7688 24.3541C10.3975 23.8453 10.1516 23.2561 10.0512 22.6343C9.9507 22.0125 9.99848 21.3758 10.1906 20.776M2.16528 8C2.54124 5.76663 3.54368 3.68592 5.05595 2M22.944 2C24.4562 3.68592 25.4587 5.76663 25.8346 8",
    stroke: "url(#paint0_linear_5197_11201)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5197_11201",
    x1: 2.16528,
    y1: 13.2912,
    x2: 25.8378,
    y2: 13.4185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRed);
export default __webpack_public_path__ + "static/media/bell-red.65e0dfa7da1121751ee145dd9320a6e4.svg";
export { ForwardRef as ReactComponent };